import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import store from "../store";
const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "Login" },
  },
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },

  //PromoCodes routes
  {
    path: "/levels",
    name: "Levels",
    component: () => import("../views/Levels/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/levels/create",
    name: "LevelCreate",
    component: () => import("../views/Levels/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/levels/:id/edit",
    name: "LevelEdit",
    component: () => import("../views/Levels/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //PromoCodes routes
  {
    path: "/promoCodes",
    name: "PromoCodes",
    component: () => import("../views/PromoCodes/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promoCodes/create",
    name: "PromoCodeCreate",
    component: () => import("../views/PromoCodes/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promoCodes/:id/edit",
    name: "PromoCodeEdit",
    component: () => import("../views/PromoCodes/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //Consultations routes
  {
    path: "/consultations",
    name: "Consultations",
    component: () => import("../views/Consultations/ConsultationList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/consultations/:id/show",
    name: "ConsultationShow",
    component: () => import("../views/Consultations/ConsultationShow.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //Consultations routes
  {
    path: "/paidConsultations",
    name: "PaidConsultations",
    component: () =>
      import("../views/PaidConsultations/PaidConsultationList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/paidConsultations/:id/show",
    name: "PaidConsultationShow",
    component: () =>
      import("../views/PaidConsultations/PaidConsultationShow.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //Availablitys routes
  {
    path: "/availabilities",
    name: "Availabilities",
    component: () => import("../views/Availability/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/availabilities/create",
    name: "AvailabilityCreate",
    component: () => import("../views/Availability/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/availabilities/:id/edit",
    name: "AvailabilityEdit",
    component: () => import("../views/Availability/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //Lessons routes
  {
    path: "/lessons",
    name: "Lessons",
    component: () => import("../views/Lessons/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/lessons/create",
    name: "LessonCreate",
    component: () => import("../views/Lessons/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/lessons/:id/edit",
    name: "LessonEdit",
    component: () => import("../views/Lessons/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //Question routes
  {
    path: "/questions",
    name: "Questions",
    component: () => import("../views/Questions/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/questions/create",
    name: "QuestionCreate",
    component: () => import("../views/Questions/Create.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/questions/:id/edit",
    name: "QuestionEdit",
    component: () => import("../views/Questions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true },
  },

  //UserTest routes
  {
    path: "/userTests",
    name: "UserTests",
    component: () => import("../views/UserTests/List.vue"),
    meta: { requiresAuth: true },
  },

  //sendEmail route
  {
    path: "/sendEmail",
    name: "SendEmail",
    component: () => import("../views/SendEmail/SendEmail.vue"),
    meta: { requiresAuth: true },
  },
  //Purchases routes
  // {
  //   path: "/purchases",
  //   name: "Purchases",
  //   component: () => import("../views/Purchases/List.vue"),
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: "/purchases/create",
  //   name: "PurchaseCreate",
  //   component: () => import("../views/Purchases/Create.vue"),
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: "/purchases/:id/edit",
  //   name: "PurchaseEdit",
  //   component: () => import("../views/Purchases/Edit.vue"),
  //   props: true,
  //   meta: { requiresAuth: true }
  // },
  //contacts routes
  {
    path: "/purchases",
    name: "Purchase",
    component: () => import("../views/Purchases/PurchaseList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/purchases/:id/show",
    name: "PurchaseShow",
    component: () => import("../views/Purchases/PurchaseShow.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  //contacts routes
  {
    path: "/contacts",
    name: "Contact",
    component: () => import("../views/Contacts/ContactList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contacts/:id/show",
    name: "ContactShow",
    component: () => import("../views/Contacts/ContactShow.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/paidConsultationList",
    name: "PaidConsultationList",
    component: () =>
      import("../views/PaidConsultations/PaidConsultationList.vue"),
    meta: { requiresAuth: true },
  },
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const isLoggedIn = store.getters["auth/isLoggedIn"];

  if (requiresAuth && !isLoggedIn) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
